// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ny2u","comment":"styles_comment__12wrv"};